import { FaqCreationPayload } from "@modules/faq/types";

import { IFaqFormData } from "./types";

export const prepareClonedData = (
  data: IFaqFormData,
): FaqCreationPayload => {
  const { ...restOfData } = data;

  return {
    ...restOfData,
  } as unknown as FaqCreationPayload;
};
